import { render, staticRenderFns } from "./TheAPISettings.vue?vue&type=template&id=0fed79be&scoped=true&"
import script from "./TheAPISettings.vue?vue&type=script&lang=js&"
export * from "./TheAPISettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fed79be",
  null
  
)

export default component.exports